export interface ISelectedRep {
    id: number;
    slpcode: number;
    username: string;
    name: string;
}

export interface IRepArea {
    userId: number;
    username: string;
    name: string;
    slpcode: number;
    statesCount: number;
    areasCount: number;
}

export interface IRepAssignedAreaFromApi {
    state: string;
    areaCode: string;
    providersCount: number;
}

export interface IRepAssignedArea {
    stateCode: string;
    stateLeadsCount: number;
    areas: Array<{
        areaCode: string;
        areaLeadsCount: number;
    }>;
}

export interface IRepAssignedAreas {
    userId: number;
    name: string;
    slpcode: number;
    states: IRepAssignedArea[];
}

export interface IStateList {
    plState: string;
    providerCount: number;
}

export interface IState {
    id: string;
    name: string;
    leadsCount: number | null;
}

export interface IStateAreaUser {
    userId: number;
    slpcode: number;
    name: string;
    primary: 1 | 0;
}

export interface IStateArea {
    areaCode: string;
    providersInAreaCode: number;
    primaryUserId: number | null;
    primaryUserName: string | null;
    primarySlpcode: number | null;
    secondaryUserId: number | null;
    secondaryUserName: string | null;
    secondarySlpcode: number | null;
}

export interface IStateAreaEditable {
    areaCode: string;
    providersInAreaCode: number;
    checked: boolean;
    assignedTo: IStateAreaUser[];
}

export type AssignUserType = 'primary' | 'secondary' | 'sole' | 'both';

export enum AssignUserStatus {
    None,
    Saving,
    Error,
    Success,
}

export interface IAssignUser {
    isBeingAssigned: boolean;
    status: AssignUserStatus;
}

export enum StateModalStatus {
    Closed,
    OpenOnRepAreasList,
    OpenOnSpecificRepArea,
    OpenOnStatesList,
    OpenOnSpecificArea,
    OpenOnLeadReps,
}

export enum AreasFilterType {
    All = 'Show both assigned and unassigned areas',
    OnlyUnassigned = 'Show only unassigned areas',
    OnlyAssigned = 'Show already assigned areas',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/interfaces/state.ts